import { SmgElement } from '../core/smg-element';
import { html, when, type SafeHtml } from '../core/safe-html';
import {
  confirmStore,
  settleConfirm,
  type ConfirmTone,
} from '../services/confirm-service';

const TONE_STYLES: Record<ConfirmTone, { bg: string; fg: string; btn: string }> = {
  primary: { bg: 'var(--vx-brand-50)', fg: 'var(--vx-primary)', btn: 'pri' },
  warning: { bg: 'var(--vx-warning-bg)', fg: 'var(--vx-warning)', btn: 'pri' },
  danger: { bg: 'var(--vx-danger-bg)', fg: 'var(--vx-danger)', btn: 'dng' },
};

/** SweetAlert tarzı evet/hayır diyaloğu — app kabuğunda tek örnek durur. */
export class SmgConfirm extends SmgElement {
  protected override onConnected(): void {
    this.bind(confirmStore);
    this.onAct('click', {
      ok: () => settleConfirm(true),
      cancel: () => settleConfirm(false),
      noop: (_el, ev) => ev.stopPropagation(),
    });
    this.addSubscription(
      (() => {
        const onKey = (ev: KeyboardEvent) => {
          if (!confirmStore.get()) return;
          if (ev.key === 'Escape') settleConfirm(false);
          if (ev.key === 'Enter') settleConfirm(true);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
      })(),
    );
  }

  protected override template(): SafeHtml {
    const req = confirmStore.get();
    return html`${when(req, () => {
      const r = req!;
      const tone = TONE_STYLES[r.tone];
      return html`
        <div class="ovl menu" data-act="cancel" style="animation:fadeIn .15s;z-index:45">
          <div class="sheet" data-act="noop" style="max-width:400px">
            <div style="padding:26px 24px 22px;text-align:center">
              <span style="width:64px;height:64px;border-radius:50%;background:${tone.bg};display:inline-flex;align-items:center;justify-content:center;margin-bottom:14px">
                <i class="${r.icon}" style="font-size:34px;color:${tone.fg}"></i>
              </span>
              <div style="font:600 17.5px var(--vx-font-sans);margin-bottom:7px">${r.title}</div>
              <p style="font:400 13.5px/1.55 var(--vx-font-sans);color:var(--vx-text-2);margin:0 0 20px">${r.message}</p>
              <div style="display:flex;gap:10px;justify-content:center">
                <button class="btn sec" style="flex:1;max-width:150px" data-act="cancel">${r.cancelLabel}</button>
                <button class="btn ${tone.btn}" style="flex:1;max-width:150px" data-act="ok">${r.okLabel}</button>
              </div>
            </div>
          </div>
        </div>`;
    })}`;
  }
}

customElements.define('smg-confirm', SmgConfirm);
